import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import { trackPage } from "./lib/analytics";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Report from "./pages/Report";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminLogin from "./pages/AdminLogin";
import History from "./pages/History";
import MyVehicles from "./pages/MyVehicles";
import RegisterVehicle from "./pages/RegisterVehicle";
import VehicleDetail from "./pages/VehicleDetail";
import ServisPanel from "./pages/ServisPanel";
import Cekici from "./pages/Cekici";
import CekiciPanel from "./pages/CekiciPanel";
import Hizmetler from "./pages/Hizmetler";
import ServisBul from "./pages/ServisBul";
import TeklifAl from "./pages/TeklifAl";
import Tekliflerim from "./pages/Tekliflerim";
import Degerleme from "./pages/Degerleme";
import GeriBildirim from "./pages/GeriBildirim";
import DevirKabul from "./pages/DevirKabul";
import Admin from "./pages/Admin";
import HesapSilme from "./pages/HesapSilme";

function Protected({ children, adminOnly = false, roles = null }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="w-10 h-10 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" state={{ from: location.pathname }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (roles && user.role !== "admin" && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rapor/:vin" element={<Report />} />
        <Route path="/giris" element={<Login />} />
        <Route path="/kayit" element={<Register />} />
        <Route path="/sifre-sifirla" element={<ForgotPassword />} />
        <Route path="/sifre-sifirla/:token" element={<ResetPassword />} />
        <Route path="/admin-giris" element={<AdminLogin />} />
        <Route path="/gecmis-sorgularim" element={<Protected><History /></Protected>} />
        <Route path="/araclarim" element={<Protected><MyVehicles /></Protected>} />
        <Route path="/araclarim/:id" element={<Protected><VehicleDetail /></Protected>} />
        <Route path="/arac-kaydet" element={<Protected><RegisterVehicle /></Protected>} />
        <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
        <Route path="/servis-panel" element={<Protected roles={["servis"]}><ServisPanel /></Protected>} />
        <Route path="/cekici-panel" element={<Protected roles={["cekici"]}><CekiciPanel /></Protected>} />
        <Route path="/cekici" element={<Protected><Cekici /></Protected>} />
        <Route path="/hizmetler" element={<Protected><Hizmetler /></Protected>} />
        <Route path="/teklif-al" element={<Protected><TeklifAl /></Protected>} />
        <Route path="/tekliflerim" element={<Protected><Tekliflerim /></Protected>} />
        <Route path="/degerleme" element={<Protected><Degerleme /></Protected>} />
        <Route path="/geri-bildirim" element={<Protected><GeriBildirim /></Protected>} />
        <Route path="/devir-kabul/:token" element={<DevirKabul />} />
        <Route path="/hesap-silme" element={<HesapSilme />} />
        <Route path="/servis-bul" element={<Protected><ServisBul /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function PageTracker() {
  const location = useLocation();
  useEffect(() => { trackPage(location.pathname); }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <PageTracker />
        <AuthProvider>
          <AppRoutes />
          <Toaster theme="light" richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
